<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.CURRENCY.SELECT"
    :handler="() => $refs.modal.show()"
  />

  <VBusHelper
    :reactOn="$constants.EVENTS.CURRENCY.SELECTED"
    :handler="() => $refs.modal.hide()"
  />

  <DialogComponent ref="modal" type="fullscreen" noInnerPadding>
    <div class="w-full h-full flex flex-col overflow-auto p-4 gap-4">
      <div class="mobile-status-padding"></div>

      <div class="px-4 py-3 bg-white border-b border-neutral-200">
        <h2 class="text-xl font-bold text-center">
          {{
            $stores.country?.state?.isMultiCurrencySelection
              ? 'Choisir des devises'
              : 'Choisir une devise'
          }}
        </h2>
        <div
          v-if="$stores.country?.state?.isMultiCurrencySelection"
          class="text-sm text-gray-500 text-center mt-1"
        >
          Sélectionnez autant de devises que vous souhaitez
        </div>
      </div>

      <div
        v-for="currency in $stores.country?.state?.currencyChoices"
        :key="currency.code"
        @click="
          $bus.emit($constants.EVENTS.CURRENCY.SELECTION_CLICKED, currency)
        "
        class="flex items-center gap-4 p-4 rounded-2xl border border-neutral-200 cursor-pointer transition-all bg-white shadow-sm hover:shadow-md"
        :class="{
          'border-amber-500! shadow-lg bg-amber-50':
            (!$stores.country?.state?.isMultiCurrencySelection &&
              $stores.country?.state?.activeCurrencyChoice?.code ===
                currency.code) ||
            ($stores.country?.state?.isMultiCurrencySelection &&
              $stores.country?.state?.selectedCurrencies.includes(
                currency.code
              ))
        }"
      >
        <div
          class="w-12 h-12 rounded-full overflow-hidden border border-neutral-200 flex items-center justify-center bg-gray-50"
        >
          <ImgComponent
            :src="`/images/flags/${currency.flag}.svg`"
            :alt="currency.name"
            class="w-full h-full object-cover"
          />
        </div>

        <div class="flex flex-col grow">
          <div class="text-lg font-semibold text-neutral-900">
            {{ currency.name }}
          </div>

          <div class="text-sm text-neutral-500 flex gap-3">
            <span class="font-mono">{{ currency.symbol }}</span>
            <span class="uppercase">🌍 {{ currency.code }}</span>
          </div>
        </div>

        <div class="text-2xl font-bold text-neutral-700">
          {{ currency.symbol }}
        </div>

        <!-- ACTIVE BADGE -->
        <div
          v-if="
            (!$stores.country?.state?.isMultiCurrencySelection &&
              $stores.country?.state?.activeCurrencyChoice?.code ===
                currency.code) ||
            ($stores.country?.state?.isMultiCurrencySelection &&
              $stores.country?.state?.selectedCurrencies.includes(
                currency.code
              ))
          "
          class="text-amber-600 font-bold text-2xl"
        >
          ✓
        </div>
      </div>

      <!-- Selection Summary (Multi-select mode) -->
      <div
        v-if="
          $stores.country?.state?.isMultiCurrencySelection &&
          $stores.country?.state?.selectedCurrencies.length > 0
        "
        class="px-4 py-3 bg-blue-50 border border-blue-200 rounded-xl mb-4"
      >
        <div class="text-sm text-blue-800 mb-2">
          {{ $stores.country?.state?.selectedCurrencies.length }} devise(s)
          sélectionnée(s) :
        </div>
        <div class="flex flex-wrap gap-2">
          <span
            v-for="code in $stores.country?.state?.selectedCurrencies"
            :key="code"
            class="px-2 py-1 bg-blue-200 text-blue-800 rounded-full text-xs font-medium"
          >
            {{ code }}
          </span>
        </div>
      </div>

      <Transition name="slide-bottom">
        <div
          class="fixed bottom-0 left-0 py-4 pb-12 bg-white w-full px-8 border-t border-neutral-200"
          v-if="
            (!$stores.country?.state?.isMultiCurrencySelection &&
              $stores.country?.state?.activeCurrencyChoice?.code) ||
            ($stores.country?.state?.isMultiCurrencySelection &&
              $stores.country?.state?.selectedCurrencies.length > 0)
          "
        >
          <button
            v-bus:EVENTS.CURRENCY.SELECTION_CONFIRMED.click
            class="buttonComponent w-full"
          >
            <span v-if="!$stores.country?.state?.isMultiCurrencySelection">
              Continuer avec
              {{ $stores.country?.state?.activeCurrencyChoice?.name }}
            </span>
            <span v-else>
              Continuer avec
              {{ $stores.country?.state?.selectedCurrencies.length }} devise(s)
            </span>
          </button>
        </div>
      </Transition>
    </div>
  </DialogComponent>
</template>

<script>
export default {
  name: 'CurrencyChoice'
};
</script>

<style scoped>
.slide-bottom-enter-active,
.slide-bottom-leave-active {
  transition: all 0.3s ease;
}

.slide-bottom-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.slide-bottom-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
